import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  of,
  throwError
} from 'rxjs';
import { AppService } from '@shared/services/core/app.service';
import { LocalStorageService } from './local-storage.service';
import { APIResponse } from '@shared/models/auth.interface';
import { Theme } from '@shared/models/theme.interface';
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private clientPortalDomain!: string;

  constructor(private _appService: AppService, private http: HttpClient, private _localStorageService: LocalStorageService,) {
    this.clientPortalDomain = this._appService.getAppConfigs()["URI"].BaseUrl;
  }

  getThemeDetail() {
    const userAuthAPIEndpoint = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions["V1"]["THEME"]["ApplicationSetting"].PATH;
    const url = this.clientPortalDomain + userAuthAPIEndpoint;
    return this.http.get<APIResponse<Theme[]>>(`${url}`);;
  }
}
